import { Injectable } from '@angular/core'
import { nginV2Headers } from '@se-po/shared-data-access-models'
import { lastValueFrom, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { SeFeApiService } from 'se-fe-api'
import { Survey } from 'se-resource-types/dist/lib/Ngin'

export enum SurveyStatus {
  Disabled = 0,
  Enabled = 1,
  Archived = 2,
  Reviewable = 3,
  UnderConstruction = 4,
}

export interface SurveyFindAllParams {
  direction?: string
  exclude_forms?: boolean
  exclude_team_only_surveys?: boolean
  fields?: string
  include_survey_summary?: boolean
  currently_open?: boolean
  name_like?: string
  order_by?: string
  organization_id: string | number
  page?: number
  per_page?: number
  sport?: string
  signup_types?: string
  status_not?: SurveyStatus | SurveyStatus[] | string
  status?: SurveyStatus | SurveyStatus[] | string
  survey_types?: string
  with_results?: boolean
  'survey_extra[available_to_registration_list]'?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  private endpoint = 'surveys'
  private cache: { [key: string]: any } = {}

  constructor(
    private api: SeFeApiService
  ) { }

  public findAll(findAllParams: SurveyFindAllParams): Observable<Survey[]> {
    const params = { ...findAllParams }
    if (params.status) params.status = params.status.toString()
    if (params.status_not) params.status_not = params.status_not.toString()

    return this.api.get<Survey[]>(this.endpoint, { params, headers: nginV2Headers })
      .pipe(map(response => response.result))
  }

  // Checks to see if there are any registrations that the current user can access
  public async organizationHasRegistrations(orgId: string): Promise<boolean> {
    const ckey = `org_${orgId}_has_registrations`
    return this.cache[ckey] ||= lastValueFrom(
      this
        .findAll({
          organization_id: orgId,
          per_page: 1,
          fields: 'id',
          exclude_forms: true,
          exclude_team_only_surveys: true,
          survey_types: 'registration',
        })
        .pipe(map((r) => !!r.length))
    )
  }

}
